import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  content
  dayDate
`

export const getSumUpDayQuery = (brandId, establishmentId, day) => {
  var debug = `
    query {
      getSumUpDay(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpDayId:"${day}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getSumUpDay(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpDayId:"${day}") {
        ${common}
      }
    }
  `;
}






